<template>
  <modal v-model="show" max-width="500">
    <Button
      slot="activator"
      class="btn-primary"
      label="Novo upload"
      @click="openModal"
    />
    <div>
      <app-form ref="videoUploadForm" @submit="onSubmit">
        <h1 class="text-muted text-center">Upload de vídeo</h1>

        <text-field
          v-model="form.name"
          label="Nome do vídeo"
          name="Nome do vídeo"
          :help="helpText"
          validate="required"
        />

        <dropzone
          v-model="form.file"
          name="Arquivo"
          ref="dropzone"
          text="Arraste e solte seu arquivo de vídeo"
          :shouldResetInput="shouldResetInput"
        />
      </app-form>
    </div>

    <template v-slot:footer>
      <app-button
        class="btn-primary"
        :label="$t('message.generics.message.save')"
        type="submit"
        flat
        primary
        @click="forceSubmit"
      >
      </app-button>
    </template>
  </modal>
</template>

<script>
import Dropzone from "@components/form/Dropzone.vue";
import AppForm from "@components/form/Form.vue";
import TextField from "@components/form/TextField.vue";
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";
import EventBus from "@packages/event-bus/index";
import Button from "@components/generic/button/Button.vue";

export default {
  components: {
    Modal,
    TextField,
    AppForm,
    AppButton,
    Dropzone,
    Button,
  },

  data() {
    return {
      infiniteId: +new Date(),
      form: {
        name: undefined,
        file: undefined,
      },
      shouldResetInput: false,
      show: false,
      helpText: `
        <div>
          <strong>Limite de Upload</strong>
          <ul style="list-style: none; margin-bottom: 10px">
            <li>- O tamanho máximo permitido para upload de vídeos é de 200 MB.</li>
            <li>- A duração máxima de cada vídeo é de 5 minutos.</li>
          </ul>          
          Certifique-se de que seu arquivo esteja dentro dessas especificações para concluir o upload com sucesso.
        </div>
      `,
    };
  },

  watch: {
    show(showing) {
      if (showing) {
        this.resetValidation();
        this.shouldResetInput = false;
        this.resetData();
      }
    },
  },

  computed: {},

  methods: {
    forceSubmit() {
      this.$refs.videoUploadForm.submit();
    },
    emitInput(newVal) {
      this.$emit("input", newVal);
      this.shouldResetInput = true;
    },
    async onSubmit() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        if (!this.isValidFileSize(this.form.file)) return;
        if (!this.isValidFileFormat(this.form.file)) return;

        const uploadURL = await this.$api.video.getUploadURL(this.form.name);
        let formData = new FormData();
        formData.append("file", this.form.file);

        await this.$api.video.upload({
          url: uploadURL,
          formData,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message:
            "Vídeo enviado para processamento com sucesso! Aguarde um instante até seu status ser atualizado",
        });

        this.$emit("on-upload");

        this.closeModal();
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status == 413) {
          EventBus.$emit("show-message", {
            type: "ERROR",
            message:
              this.$t("message.errorMessages.message.fileToBig") + "200MB",
          });
        }
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    isValidFileSize(file) {
      const MAX_MB = 200;
      const fileSize = MAX_MB * 1024 * 1024;

      if (file.size > fileSize) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: this.$t("message.errorMessages.message.fileToBig") + "200MB",
        });
        return false;
      }
      return true;
    },
    isValidFileFormat(file) {
      const allowedFormats = [
        "video/mp4",
        "video/webm",
        "video/mov",
        "video/x-matroska",
        "video/x-msvideo",
        "video/x-flv",
        "video/mp2t",
      ];

      if (!allowedFormats.includes(file.type)) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: this.$t("message.errorMessages.message.invalidFileFormat"),
        });
        return false;
      }
      return true;
    },
    resetData() {
      this.form = {
        name: undefined,
        file: undefined,
      };
    },
    resetValidation() {
      this.$refs.videoUploadForm.reset();
    },
    closeModal() {
      this.show = false;
    },
    openModal() {
      this.show = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
